import script from "./EmploymentData.vue?vue&type=script&setup=true&lang=js"
export * from "./EmploymentData.vue?vue&type=script&setup=true&lang=js"

import "./EmploymentData.vue?vue&type=style&index=0&id=28642664&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28642664"]])

export default __exports__